<div [class]="(view$ | async) === VIEWS.WIZARD ? 'scheduler-setup-container' : 'scheduler-settings-container'">
  <div class="top-spacer"></div>
  @switch (view$ | async) {
    <!-- TODO: Do we need this? Can we make this better? It wasn't around before-->
    @case (VIEWS.LOADING) {
    }
    @case (VIEWS.WIZARD) {
      <meeting-scheduler-settings-wizard
        [isHostConfigured]="isHostConfigured$ | async"
        [isGoogleMeetConfigured]="isGoogleMeetConfigured$ | async"
        [isMicrosoftConfigured]="isMicrosoftConfigured$ | async"
        [hostPreferences]="hostPreferences$ | async"
        [initialSlug]="personalCalendarSlug$ | async"
        [hostId]="hostId$ | async"
      ></meeting-scheduler-settings-wizard>
    }
    @case (VIEWS.SETTINGS) {
      <meeting-scheduler-settings
        [isHostConfigured]="isHostConfigured$ | async"
        [isGoogleMeetConfigured]="isGoogleMeetConfigured$ | async"
        [isMicrosoftConfigured]="isMicrosoftConfigured$ | async"
        [hostPreferences]="hostPreferences$ | async"
      ></meeting-scheduler-settings>
    }
  }
</div>
